// dom工具类
import { isMobileUA } from './common-util' // isAndroid, isIOS

/**
 * 获取元素距离顶部值
 */
const getScrollTop = (e) => {
    let offset = e.offsetTop
    if (e.offsetParent != null) {
        offset += getScrollTop(e.offsetParent)
    }
    return offset
}

/**
 * 验证当前激活元素为input
 */
const verifyActiveEleIsInput = () => {
    if (document.activeElement) {
        const { activeElement } = document
        const nodeName = activeElement.nodeName.toLowerCase()
        // console.log('activeElement', activeElement)
        const nodeReadonly = activeElement.getAttribute('readonly')
        const nodeDisabled = activeElement.getAttribute('disabled')
        // const nodeContenteditable = activeElement.getAttribute('contenteditable') // 是否为可编辑元素 || nodeContenteditable
        // console.log('nodeReadonly\nodeDisabled', nodeReadonly, nodeDisabled, (nodeName === 'input' || nodeName === 'textarea') && nodeReadonly !== 'readonly' && nodeDisabled !== 'disabled')
        return (nodeName === 'input' || nodeName === 'textarea') && nodeReadonly !== 'readonly' && nodeDisabled !== 'disabled'
    }
    return false
}

/**
 * 验证当前激活元素为可编辑元素
 */
// const verifyActiveEleIsEditable = () => {
//     if (document.activeElement) {
//         const nodeContenteditable = document.activeElement.getAttribute('contenteditable') // 是否为可编辑元素 || nodeContenteditable
//         return nodeContenteditable
//     }
//     return false
// }

/**
 * 输入框获取焦点 滚动到对应位置
 */
const inputFocusScrollIntoView = ({ useRem }) => {
    // 获取当前屏幕可视区域高度
    const viewHeight = window.outerHeight || (window.screen && window.screen.height)
    // 获取当前输入框距离顶部
    const activeEleScrollTop = getScrollTop(document.activeElement)

    // 判断是否为popup激活状态
    const vanPopups = document.getElementsByClassName('van-popup')
    const vanOverlay = document.getElementsByClassName('van-overlay')
    const vanOverflowHidden = document.getElementsByClassName('van-overflow-hidden')

    let vanPopupFlag = false

    if (vanPopups && vanPopups.length && vanOverlay && vanOverlay.length && vanOverflowHidden && vanOverflowHidden.length) {
        // 遍历所有popup找到正在展现的 + 同时不是notify
        for (let i = 0; i < vanPopups.length; i++) {
            const vanPopup = vanPopups[i]
            if (vanPopup && vanPopup.style.display !== 'none' && vanPopup.className.indexOf('van-notify') < 0) {
                // 计算当前popup高度
                const vanPopupHei = (viewHeight * (parseInt(vanPopup.style.height, 10) / 100))
                // vanPopup滚动到对应位置
                vanPopup.scrollTo(0, activeEleScrollTop - (viewHeight - vanPopupHei + 47 + 15))
                vanPopupFlag = true
                break
            }
        }
    }

    if (!vanPopupFlag) {
        // 获取当前滚动位置 pageYOffset || scrollY
        const scrollY = window.pageYOffset || window.scrollY

        // 规则：计算为负数则滚动、正数不滚动
        const scrollCha = (viewHeight / 2) - (activeEleScrollTop - scrollY)
        // console.log('计算差scrollCha', scrollCha, activeEleScrollTop, viewHeight, scrollY)
        if (scrollCha < 0) {
            // 当滚动差 > 1/4屏高度时，直接为activeEleScrollTop，否则为半屏高+已滚动值
            const scrollTopVal = (-scrollCha) > (viewHeight / 4) ? activeEleScrollTop : (viewHeight / 2) + scrollY
            setTimeout(() => {
                document.body.style.paddingBottom = useRem ? '7.25rem' : '350px'
                window.scrollTo(0, scrollTopVal)
            }, 300)
        }
    }
}

/**
 * 移动端输入框获取焦点后自动滚动到位置
 */
const inputScrollIntoView = ({ useRem }) => {
    if (!isMobileUA) {
        return
    }
    document.addEventListener('click', () => {
        // 当是input\textarea时滚屏到位置
        if (verifyActiveEleIsInput()) {
            inputFocusScrollIntoView({
                useRem,
            })
        } else if (document.body.style.paddingBottom !== '0px') { // 当不是at输入框+ 还是paddingBottom时延时
            setTimeout(() => {
                document.body.style.paddingBottom = '0'
            }, 250)
        }
    })
}

export {
    getScrollTop,
    inputScrollIntoView,
}
